import React from "react";
import { Link } from "react-router-dom";
import "./NotFoundPage.css";

function NotFoundPage() {
  return (
    <>
      <img className="cover" src={"https://i.imgur.com/goREv4a.jpg"} />
    </>
  );
}
export default NotFoundPage;
